import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api";
import { useAuth } from "../auth/AuthContext";

export default function ChangePassword() {
    const { refresh } = useAuth();
    const nav = useNavigate();

    const [oldPass, setOldPass] = useState("");
    const [newPass, setNewPass] = useState("");
    const [busy, setBusy] = useState(false);
    const [msg, setMsg] = useState("");
    const [err, setErr] = useState("");

    async function onSubmit(e) {
        e.preventDefault();
        setErr("");
        setMsg("");
        setBusy(true);
        try {
            await api.changePassword(oldPass, newPass);
            await refresh();
            setMsg("Heslo bylo změněno.");
            nav("/", { replace: true });
        } catch (e2) {
            setErr(e2 && e2.message ? e2.message : "change_failed");
        } finally {
            setBusy(false);
        }
    }

    return (
        <div className="card overflow-hidden">
            <div className="cardHeader">
                <div className="text-text-100 font-bold text-2xl">Změna hesla</div>
                <div className="text-text-300 mt-2">Povinné při prvním přihlášení</div>
            </div>

            <div className="cardBody">
                <form onSubmit={onSubmit} className="space-y-6">
                    <div>
                        <div className="label">Staré heslo</div>
                        <input value={oldPass} onChange={(e) => setOldPass(e.target.value)} className="input mt-3" type="password" autoComplete="current-password" />
                    </div>

                    <div>
                        <div className="label">Nové heslo</div>
                        <input value={newPass} onChange={(e) => setNewPass(e.target.value)} className="input mt-3" type="password" autoComplete="new-password" />
                    </div>

                    {err ? (
                        <div className="rounded-2xl border border-bad/35 bg-bad/10 p-4">
                            <div className="text-text-100 font-semibold">Nešlo změnit</div>
                            <div className="text-text-200 text-sm mt-1">{err}</div>
                        </div>
                    ) : null}

                    {msg ? (
                        <div className="rounded-2xl border border-ok/35 bg-ok/10 p-4">
                            <div className="text-text-100 font-semibold">{msg}</div>
                        </div>
                    ) : null}

                    <button disabled={busy} className={busy ? "btnPrimary opacity-60 cursor-not-allowed" : "btnPrimary"}>
                        {busy ? "Ukládám" : "Změnit heslo"}
                    </button>
                </form>
            </div>
        </div>
    );
}
